module.exports = __webpack_public_path__ + "static/media/cubicbezier.fabb7c83.png";